class ResponsiveNavbarController {
    public static $inject: string[] = [
        "$state"
    ];

    private $element;

    constructor(
        private $state: ng.ui.IStateService
    ) {}

    public $onInit() {
        this.$element = document.getElementById("responsive-navbar-wrapper");
    }

    public $postLink() {
        const currentStateName: string = this.$state.current.name.split(".").splice(-1).pop();
        const currentNavItem = <HTMLLIElement>this.$element.querySelector(
            `.md-nav-item[name='${ currentStateName }']`
        );
        const navItems = <NodeList>this.$element.querySelectorAll(".md-nav-item");

        if (currentNavItem) {
            this._scrollTo(currentNavItem.offsetLeft);
        }

        for (const item of navItems as any) {
            item.addEventListener("click", () => this._scrollTo(item.offsetLeft));
        }
    }

    public paginate({ end } = { end: false }) {
        const offsetLeft = end ? this.$element.offsetWidth : 0;
        this._scrollTo(offsetLeft);
    }

    private _scrollTo(offsetLeft) {
        this.$element.scroll({
            top: 0,
            left: offsetLeft,
            behavior: "smooth"
        });
    }
}

angular
    .module("thor.shared.responsive-navbar.component", [])
    .component("responsiveNavbar", {
        controller: ResponsiveNavbarController,
        controllerAs: "responsiveNavbar",
        template: require("../../shared/responsive-navbar/responsive-navbar.html"),
        transclude: true
    });
